import { CircularProgress } from '@mui/material';
import { OrganisationCodeReturnPath as OrganisationCodeReturnPathComponent } from '@verifime/components';
import { TNotificationHandler } from '../../../types';
import { useOrganisationCodeReturnPath } from './hooks/useOrganisationCodeReturnPath';

export interface OrganisationCodeReturnPathProps {
  organisationId: string;
  successNotificationHandler?: TNotificationHandler;
  errorNotificationHandler?: TNotificationHandler;
}

export default function OrganisationCodeReturnPath({
  organisationId,
  successNotificationHandler,
  errorNotificationHandler,
}: Readonly<OrganisationCodeReturnPathProps>) {
  const {
    selectedCode,
    setSelectedCode,
    isLoading,
    organisationCodes,
    initialReturnUrl,
    handleSave,
  } = useOrganisationCodeReturnPath(
    organisationId,
    successNotificationHandler,
    errorNotificationHandler,
  );

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <OrganisationCodeReturnPathComponent
      key={organisationId + selectedCode}
      organisationCodes={organisationCodes}
      selectedCode={selectedCode}
      initialReturnUrl={initialReturnUrl}
      onSave={handleSave}
      onCodeChange={setSelectedCode}
    />
  );
}
